import * as Yup from "yup";
import { OMN_COUNTRY_CODE } from "../constants/defaults";
import { omanVatRule } from "./omanVatValidation";
export const SupplierValidation = (messages = {}) => {
  return Yup.object().shape({
    name: Yup.string().required("Name is required"),
    party_name: Yup.string().required("Business name is required"),
    party_name_in_local_language: Yup.string().nullable(),
    email: Yup.string()
      .required("Email is required")
      .email("Email is not a valid email")
      .max(320, "Maximum 320 characters"),
    postal_address: Yup.object().shape({
      street_name: Yup.string().required("Street name is required"),
      additional_street_name: Yup.string().required(
        "Additional street name is required",
      ),
      address_line: Yup.string().required("Address line is required"),
      city_name: Yup.string().required("City is required"),
      country_subentity: Yup.mixed().when("country_code", ([country_code]) => {
        if (country_code?.code === OMN_COUNTRY_CODE) {
          return Yup.object()
            .shape({
              code: Yup.string().required("Country subentity is required"),
              name: Yup.string().required(),
            })
            .required("Country subentity is required");
        }

        return Yup.string().required("Country subentity is required");
      }),
      country_code: Yup.object()
        .shape({
          code: Yup.string().required("Country code is required"),
          label: Yup.string().required("Country label is required"),
        })
        .required("Country code is required"),
      postal_zone: Yup.string().required("Postal zone is required"),
    }),
    telephone: Yup.string().required("Telephone is required"),
    scheme_agency_id: Yup.mixed().when("postal_address.country_code", {
      is: (country) => country?.code === OMN_COUNTRY_CODE,
      then: () => Yup.object().required("Registration type is required"),
      otherwise: () => Yup.mixed().nullable(),
    }),
    company_id: Yup.string().when(
      ["scheme_agency_id", "postal_address.country_code"],
      {
        is: (scheme, country) => {
          if (scheme) {
            return true;
          }
          return country?.code === OMN_COUNTRY_CODE;
        },
        then: (schema) => schema.required("Registration number is required"),
        otherwise: (schema) => schema.nullable(),
      },
    ),
    passport_issuing_country_code: Yup.mixed().nullable(),
    party_tax_scheme: Yup.mixed().when("postal_address.country_code", {
      is: (val) => val?.code === OMN_COUNTRY_CODE,
      then: () =>
        Yup.object().shape({
          tax_scheme: Yup.string().required("Tax scheme is required"),
          company_id: omanVatRule(Yup.string()),
        }),
      otherwise: (schema) => schema.nullable(),
    }),
    endpoint_scheme_id: Yup.mixed().when("postal_address.country_code", {
      is: (country) => country?.code === OMN_COUNTRY_CODE,
      then: () => Yup.object().required("Endpoint scheme id is required"),
      otherwise: () => Yup.mixed().nullable(),
    }),
    endpoint_id: Yup.string().when("postal_address.country_code", {
      is: (country) => country?.code === OMN_COUNTRY_CODE,
      then: () => Yup.string().required("Endpoint id is required"),
      otherwise: () => Yup.string().nullable(),
    }),
    logo_url: Yup.string().nullable(),
  });
};
